import { FETCH_DATA_SOURCE_CONDITIONS } from "../types/dataSourceCondition";

export const fetchDataSourceConditions = () => {
  return dispatch => {
    dispatch({
      type: FETCH_DATA_SOURCE_CONDITIONS
    });
  };
};
